
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';

@Component
export default class Support extends Vue {
  public dialog = false;
  public supportDialog = false;
  public formTitle = 'ثبت تیکت';
  public content = '';
  public selectedSupportId = 0;
  public desserts = [];
  public supports = [];
  public businessUnits = [];
  public productCategories = [];
  public supportSubjects = [];
  public headers = [
    { text: 'شماره پیگیری', value: 'id' },
    { text: 'تاریخ', value: 'supportDate' },
    { text: 'واحد', value: 'businessUnit' },
    { text: 'موضوع', value: 'supportSubject' },
    { text: 'وضعیت', value: 'supportStatus' },
    { text: 'پاسخ', value: 'action', sortable: false }
  ];
  public editedItem = {
    id: 0,
    content: '',
    businessUnitId: 0,
    supportSubjectId: 0,
    productCategoryId: 0
  };
  public defaultItem = {
    id: 0,
    content: '',
    businessUnitId: 0,
    supportSubjectId: 0,
    productCategoryId: 0
  };
  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: 'پشتیبانی',
      disabled: true,
      href: ''
    }
  ];

  async created() {
    await this.initialize();
  }

  async initialize() {
    this.$showLoading();
    await Api.getProductCategories().then((response: any) => {
      this.productCategories = response.data;
    });
    await Api.getBusinessUnits().then((response: any) => {
      this.businessUnits = response.data;
    });
    await Api.getSupports().then((response: any) => {
      this.desserts = response.data;
      this.$hideLoading();
    });
  }

  async close() {
    this.dialog = false;
    this.supportDialog = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.content = '';
      this.selectedSupportId = 0;
    });

    await this.initialize();
  }

  async saveSupport() {
    const isValid = (this.$refs.Observer as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    await Api.createSupport(
      this.editedItem.content,
      this.editedItem.businessUnitId,
      this.editedItem.supportSubjectId,
      this.editedItem.productCategoryId
    ).then((response: any) => {
      this.$showNotification('success', 'درخواست پشتیبانی ثبت شد');
      this.close();
      this.$hideLoading();
    });
  }

  async saveSupportItem() {
    const isValid = (this.$refs.Observer as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    await Api.createSupportItem(this.selectedSupportId, this.content).then((response: any) => {
      this.supportDialog = false;
      this.close();
      this.$hideLoading();
    });
  }

  async getSelectedSupportSubjectProduct() {
    this.$showLoading();
    await Api.getSelectSupportSubjects(this.editedItem.productCategoryId, this.editedItem.businessUnitId).then((response: any) => {
      this.supportSubjects = response.data;
      this.$hideLoading();
    });
  }

  async getSupportItemList(id: number) {
    this.selectedSupportId = id;
    this.$showLoading();
    await Api.getSupportItems(id).then((response: any) => {
      this.supports = response.data;
      this.$nextTick(() => {
        this.supportDialog = true;
      });
      this.$hideLoading();
    });
  }

  getColor(supportStatus: string) {
    if (supportStatus === 'ارسال شده') {
      return 'primary';
    }
    if (supportStatus === 'پاسخ داده شده') {
      return 'secondary';
    } else {
      return 'green lighten-1';
    }
  }
}
